import React, { ReactNode, RefObject } from "react";
import { RefCallBack } from "react-hook-form";
import classnames from "classnames";
import Radio from "./Radio";
import styles from "./Radio.module.css";

export interface IRadioProps {
  label?: string;
  labelHidden?: boolean;
  name: string;
  items: {
    value: string;
    text: string;
    description?: string;
    id?: number;
    idForText?: number | string;
    image?: string;
  }[];
  selectedValue?: string;
  onChange: (value: string) => void;
  children?: ReactNode;
  fullWidth?: boolean;
  disabled?: boolean;
  noBorder?: boolean;
  step?: number;
  wrapperStyle?: React.CSSProperties;
  inputRef?: RefObject<HTMLInputElement> | RefCallBack;
  dataCy?: string;
}

export const RadioGroup = ({
  label,
  labelHidden,
  name,
  items,
  selectedValue,
  onChange,
  children = null,
  fullWidth,
  disabled,
  noBorder,
  step = 0,
  wrapperStyle,
  inputRef,
  dataCy,
}: IRadioProps) => (
  <fieldset className={styles.radioGroupFieldset}>
    {label && (
      <legend className={labelHidden ? "visuallyHidden" : ""}>{label}</legend>
    )}
    <div
      data-cy={dataCy}
      className={classnames({
        [styles.radioGroupWrapper]: true,
        [styles.fullWidth]: fullWidth,
        [styles.disabled]: disabled,
        [styles.noBorder]: noBorder,
      })}
      style={wrapperStyle}
    >
      {items.map((item) => (
        <Radio
          inputRef={inputRef}
          inputId={item.id ? `${item.id + step}` : `undefined${step}`}
          key={item.value}
          name={name}
          value={item.value}
          text={item.text}
          description={item.description}
          checked={item.value === selectedValue}
          onChange={(e) => onChange(e.currentTarget.value)}
          idForText={item.idForText}
          image={item.image}
          disabled={disabled}
        />
      ))}
      {children}
    </div>
  </fieldset>
);

export default RadioGroup;
